// extracted by mini-css-extract-plugin
export default {"error":"EventMessage_error__ZFDr4","eventContainer":"EventMessage_eventContainer__xky0n","eventHeader":"EventMessage_eventHeader__WGDrP"};